define("shared/utils/constants/linkinbio-block-types", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  var BlockTypes = /*#__PURE__*/function (BlockTypes) {
    BlockTypes["App"] = "app";
    BlockTypes["ButtonList"] = "button_list";
    BlockTypes["ContactCollection"] = "contact_collection";
    BlockTypes["EmailCollection"] = "email_collection";
    BlockTypes["FeaturedBanner"] = "featured_banner";
    BlockTypes["FeaturedMedia"] = "featured_media";
    BlockTypes["Feed"] = "feed";
    BlockTypes["FeedList"] = "feed_list";
    BlockTypes["Gallery"] = "gallery";
    BlockTypes["Header"] = "header";
    BlockTypes["Mavely"] = "mavely";
    BlockTypes["MultiItemBanner"] = "multi_item_banner";
    BlockTypes["Seo"] = "seo";
    BlockTypes["SocialLinkList"] = "social_link_list";
    BlockTypes["Style"] = "style";
    BlockTypes["Utm"] = "utm";
    return BlockTypes;
  }(BlockTypes || {});
  var _default = _exports.default = BlockTypes;
});